import { ButtonProps } from "@src/components/ui-components/Buttons/Button/Button";
import { t } from "i18next";
import { DataObjectHelper } from "../../../to-be-removed/LocalData/General/DataObjects/DataObjectHelper";
import { Label } from "../Label/Label";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { MultiSelectPopup } from "../MultiSelectPopup/MultiSelectPopup";
import { PhoneNumberFieldModalPopup } from "../PhoneNumberEditorPopup/PhoneNumberEditorPopup";
import { Popup } from "../Popup/Popup";
import { SelectPopup } from "../SelectPopup/SelectPopup";
import { Text } from "../Text/Text";
import { TextFieldModalPopup } from "../TextFieldModalPopup/TextFieldModalPopup";

export class PopupTemplates {
  static presentVerifyAction(
    title: string,
    description: string,
    onVerified: () => void,
    actionTitle?: string,
    actionButtonType?: ButtonProps["type"]
  ) {
    return Popup.present((id) => (
      <ModalPopup
        id={id}
        title={title}
        onActionClicked={() => onVerified()}
        containerProps={{ maxWidth: "50%" }}
        actionButtonType={actionButtonType}
        actionTitle={actionTitle}
        children={<Label type="paragraph" text={description} />}
      />
    ));
  }
  static presentVerifyDelete(name: string, onVerified: () => void, description: string = t("main.cannotBeUndone")) {
    return Popup.present((id) => (
      <ModalPopup
        id={id}
        title={t("main.verifyDelete", { name })}
        onActionClicked={() => onVerified()}
        containerProps={{ maxWidth: "50%" }}
        actionButtonType="danger"
        actionTitle={t("main.delete")}
        children={<Text size="sm">{description}</Text>}
      />
    ));
  }
  static presentVerifyDeleteDatas(
    helper: DataObjectHelper<any>,
    names: string[],
    onVerified: () => void,
    description: string = t("main.cannotBeUndone")
  ) {
    if (names.length === 1) {
      this.presentVerifyDelete(names[0], onVerified, description);
    } else {
      return Popup.present((id) => (
        <ModalPopup
          id={id}
          title={t("main.verifyDelete", { name: `${names.length} ${helper.displayName().toLowerCase()}` })}
          onActionClicked={() => onVerified()}
          containerProps={{ maxWidth: "50%" }}
          actionButtonType="danger"
          actionTitle={t("main.delete")}
          children={<Text size="sm">{description}</Text>}
        />
      ));
    }
  }
  static presentVerifyActionForDatas(
    title: string,
    helper: DataObjectHelper<any>,
    names: string[],
    onVerified: () => void,
    description: string = t("main.cannotBeUndone")
  ) {
    if (names.length === 1) {
      this.presentVerifyAction(`${title}?`, description, onVerified);
    } else {
      return Popup.present((id) => (
        <ModalPopup
          id={id}
          title={`${title} ${names.length} ${helper.displayName().toLowerCase()}?`}
          onActionClicked={() => onVerified()}
          containerProps={{ maxWidth: "50%" }}
          actionButtonType="danger"
          actionTitle={t("main.confirm")}
          children={<Text size="sm">{description}</Text>}
        />
      ));
    }
  }

  static presentTextInput({
    title,
    placeholder,
    onConfirm,
    actionTitle,
    actionButtonType,
    defaultValue,
    label,
    dataCy,
  }: {
    title: string;
    placeholder: string;
    onConfirm: (popUpId: string, name: string) => void;
    actionTitle?: string;
    actionButtonType?: ButtonProps["type"];
    defaultValue?: string;
    label?: string;
    dataCy?: string;
  }) {
    return Popup.present((id) => (
      <TextFieldModalPopup
        id={id}
        title={title}
        placeholder={placeholder}
        onConfirm={onConfirm}
        actionTitle={actionTitle}
        defaultValue={defaultValue}
        actionButtonType={actionButtonType}
        label={label}
        dataCy={dataCy}
      />
    ));
  }

  static presentPhoneNumberInput(
    title: string,
    placeholder: string,
    onSubmit: (popUpId: string, name: string) => void,
    actionTitle?: string,
    actionButtonType?: ButtonProps["type"],
    defaultText?: string
  ) {
    return Popup.present((id) => (
      <PhoneNumberFieldModalPopup
        id={id}
        title={title}
        placeholder={placeholder}
        onSubmit={onSubmit}
        actionTitle={actionTitle}
        defaultText={defaultText}
        actionButtonType={actionButtonType}
      />
    ));
  }

  static presentSelectInput(
    title: string,
    placeholder: string | undefined,
    options: { key: string; title: string }[],
    didSelect: (key: string) => void,
    defaultSelected?: string
  ) {
    return Popup.present((id) => (
      <SelectPopup defaultSelected={defaultSelected} didSelect={didSelect} id={id} options={options} placeholder={placeholder} title={title} />
    ));
  }

  static presentMultiSelectInput(
    title: string,
    placeholder: string | undefined,
    options: { key: string; title: string }[] | Promise<{ key: string; title: string }[]>,
    didSelect: (keys: string[]) => void,
    defaultSelected?: string[],
    label?: string
  ) {
    return Popup.present((id) => (
      <MultiSelectPopup
        defaultSelected={defaultSelected}
        didSelect={didSelect}
        id={id}
        options={options}
        placeholder={placeholder}
        title={title}
        label={label}
      />
    ));
  }
}
